export enum DeviceType {
  'Android' = 'Android',
  'iOS' = 'iOS',
}
